import styles from './MaskContent.module.scss';

import clsx from 'clsx';
import { useRef } from 'react';

import { useMaskContext } from '../../hooks/mask-context';
import { useDnDScroll } from '../../views/erp/components/tab-panels/positions/components/edit-table/hooks/use-dnd-scroll';

export interface MaskContentProps {
  children?: React.ReactNode;
  className?: string;
}

export function MaskContent(props: MaskContentProps) {
  const { children, className } = props;

  const ctx = useMaskContext();

  const scrollContainer = useRef(null);
  useDnDScroll(scrollContainer.current);

  return (
    <div
      className={clsx(styles.root, className)}
      id="settingsWrapper"
      data-test-id={`settingsWrapper-${ctx.entity}`}
    >
      <div ref={scrollContainer} className={styles.scroll}>
        {children}
      </div>
    </div>
  );
}
